import { useContext } from 'react';
import { AppContext } from '../AppContext';

const useToyDrawer = () => {
  const { dispatch } = useContext(AppContext);

  const openToyDrawer = (toyId, { isLibrary = false } = {}) => {
    if (!toyId) return;
    dispatch({
      type: 'SET_TOY_DRAWER',
      data: { visible: true, toyId, isLibrary, isCreate: false, isEdit: false },
    });
  };

  const openToyEditDrawer = (toyId) => {
    if (!toyId) return;
    dispatch({
      type: 'SET_TOY_DRAWER',
      data: {
        visible: true,
        toyId,
        isLibrary: false,
        isCreate: false,
        isEdit: true,
      },
    });
  };

  const openToyCreateDrawer = () => {
    dispatch({
      type: 'SET_TOY_DRAWER',
      data: {
        visible: true,
        toyId: null,
        isLibrary: false,
        isCreate: true,
        isEdit: false,
      },
    });
  };

  return { openToyDrawer, openToyCreateDrawer, openToyEditDrawer };
};

export default useToyDrawer;
